import { useEffect } from "react";

let scriptPromise = null;

function loadGiveButter() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    if (document.querySelector('script[data-givebutter]')) return resolve();
    const s = document.createElement("script");
    s.src = "https://widgets.givebutter.com/latest.umd.cjs";
    s.async = true;
    s.setAttribute("data-givebutter", "true");
    s.onload = () => resolve();
    document.body.appendChild(s);
  });
  return scriptPromise;
}

export const GiveButter = ({ widgetId = "Ly87xj", className = "" }) => {
  useEffect(() => {
    loadGiveButter();
  }, []);

  return (
    <div className={className} data-testid="givebutter-widget">
      <givebutter-widget id={widgetId}></givebutter-widget>
    </div>
  );
};
